import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { IOtherPlayer } from '../types/IPlayerView';
import { ImagePicker } from '../utils/imagePicker';
import ScenarioUtils from '../utils/scenarioUtils';
import './CharCard.scss';
import { PlayerStatusEnum } from '../types/playerStatusEnum';

export default function CharCard(props: {player: IOtherPlayer, playerPosition: number, isDead: boolean}) {
    const { playerName} = useSelector((state: RootState) => state.general);
    const { playerRole, playerView } = useSelector((state: RootState) => state.game);
    const {player, playerPosition, isDead} = props;

    const playerStatus = ScenarioUtils.GetOtherPlayerStatus(playerName === player.name, playerRole, playerView?.is_dead === true, player.role_name, player.is_dead);
    const showClass = playerStatus !== PlayerStatusEnum.Hidden;
    const customClass = player.is_dead ? `char-name neutral dead` : showClass ? 'mark' : 'char-name';
    const className = (showClass) ? <span>{player.role_name}</span> : <></>

    return <div className={`char-card`}>
        <div className='char-img'>
            <img src={ImagePicker.GetImage(playerPosition, isDead)}></img>
        </div>
        <div className={` char-card-name ${customClass}`}>{className} {`${player.name}`}</div>
    </div>
}